(() => {
  const formatMoney = (cents, currency, locale) => {
    try { return new Intl.NumberFormat(locale || document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100); }
    catch (e) { return ((Number(cents) || 0) / 100).toFixed(2); }
  };

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('.product-form');
    if (!form) return;
    const qtyInput = form.querySelector('[data-quantity-input]');
    const buyNowForm = section.querySelector('.buy-now-form');
    const buyNowQty = buyNowForm?.querySelector('[data-buy-now-quantity]');
    const buyNowVariant = buyNowForm?.querySelector('[data-buy-now-variant]');
    const expressForm = section.querySelector('.express-checkout-native-form');
    const expressQty = expressForm?.querySelector('[data-express-quantity]');
    const expressVariant = expressForm?.querySelector('[data-express-variant]');
    const variantSelect = form.querySelector('[data-variant-select]');
    const unitPrice = section.querySelector('[data-unit-price]');
    const currency = section.dataset.currency || 'USD';
    const locale = document.documentElement.lang || 'en';
    let unitCents = Number(section.dataset.basePrice || 0);
    let compareCents = Number(section.dataset.baseCompare || 0);

    const updateOffers = () => {
      section.querySelectorAll('[data-quantity]').forEach((button) => {
        const qty = Number(button.dataset.quantity || 1);
        const discount = Number(button.dataset.discount || 0);
        const total = Math.round(unitCents * qty * (100 - discount) / 100);
        const price = button.querySelector('[data-bundle-price]');
        if (price) price.textContent = formatMoney(total, currency, locale);
        const regular = button.querySelector('[data-bundle-regular]');
        if (regular) regular.textContent = formatMoney(unitCents * qty, currency, locale);
      });
      if (unitPrice) unitPrice.textContent = formatMoney(unitCents, currency, locale);
      const comparePrice = section.querySelector('[data-compare-price]');
      const saleBadge = section.querySelector('[data-sale-badge]');
      if (comparePrice) {
        comparePrice.textContent = formatMoney(compareCents, currency, locale);
        comparePrice.hidden = compareCents <= unitCents;
      }
      if (saleBadge) saleBadge.hidden = compareCents <= unitCents;
    };

    section.querySelectorAll('[data-quantity]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-quantity]').forEach((other) => {
          other.classList.remove('is-selected');
          other.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (qtyInput) qtyInput.value = button.dataset.quantity;
        if (buyNowQty) buyNowQty.value = button.dataset.quantity;
        if (expressQty) expressQty.value = button.dataset.quantity;
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const selected = variantSelect.options[variantSelect.selectedIndex];
        unitCents = Number(selected.dataset.price || 0);
        compareCents = Number(selected.dataset.compare || 0);
        if (buyNowVariant) buyNowVariant.value = selected.value;
        if (expressVariant) expressVariant.value = selected.value;
        updateOffers();
      });
    }

    section.querySelectorAll('[data-gallery-image]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = section.querySelector('.product-main-image img');
        if (image) image.src = button.dataset.galleryImage;
      });
    });

    updateOffers();
  });

  document.querySelectorAll('[data-results-track]').forEach((track) => {
    const section = track.closest('.results-section');
    if (!section) return;
    const cards = Array.from(track.querySelectorAll('[data-result-card]'));
    const dots = Array.from(section.querySelectorAll('[data-result-dot]'));
    const updateDots = () => {
      if (!cards.length || !dots.length) return;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      const step = cards[0].getBoundingClientRect().width + gap;
      const index = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step)));
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const scrollToIndex = (index) => {
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      const step = cards[0]?.getBoundingClientRect().width + gap;
      if (step) track.scrollTo({ left: index * step, behavior: 'smooth' });
    };
    section.querySelector('[data-results-prev]')?.addEventListener('click', () => {
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      track.scrollBy({ left: -(cards[0]?.getBoundingClientRect().width + gap || track.clientWidth), behavior: 'smooth' });
    });
    section.querySelector('[data-results-next]')?.addEventListener('click', () => {
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      track.scrollBy({ left: cards[0]?.getBoundingClientRect().width + gap || track.clientWidth, behavior: 'smooth' });
    });
    dots.forEach((dot) => dot.addEventListener('click', () => scrollToIndex(Number(dot.dataset.resultDot || 0))));
    track.addEventListener('scroll', updateDots, { passive: true });
    window.addEventListener('resize', updateDots, { passive: true });
    updateDots();
  });

  const stickyBar = document.querySelector('[data-sticky-atc]');
  const productSection = document.querySelector('[data-product-section]');
  if (stickyBar && productSection) {
    const toggleSticky = () => {
      const productBottom = productSection.getBoundingClientRect().bottom;
      stickyBar.classList.toggle('is-visible', window.scrollY > 380 && productBottom < 120);
    };
    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky, { passive: true });
    toggleSticky();
    stickyBar.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      const addButton = productSection.querySelector('[data-add-button]');
      addButton?.click();
    });
  }
})();
